import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col',
    searchContainer: 'p-4 pb-[32px]',
    categories: 'mb-[18px] px-[20px]',
    contact: 'flex flex-col gap-[24px] px-[20px] py-[32px]',
    contactDetails: 'flex flex-col gap-[16px]',
    main: 'mb-[24px] flex flex-row items-center justify-between px-[12px] py-[17px]',
    close: '',
    closeIcon: 'size-[28px] [&>path]:stroke-white',
    logo: '',
    logoIcon: 'w-full max-w-[144px]',
    search: '',
    searchIcon: 'size-[28px] [&>path]:fill-white',
    contactLink:
      'text-m leading-[140%] font-medium text-white hover:opacity-75',
    contactSocials: 'flex flex-row gap-[16px] py-[8px]',
    socialsLink: 'opacity-50 hover:opacity-100',
    socialIcon: '[&>path]:fill-white',
    item: 'font-regular text-m flex flex-row gap-[24px] py-[12.5px] leading-[140%] tracking-[2%] text-white',
    itemLabel: 'flex w-full gap-2.5'
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
